module.exports = __webpack_public_path__ + "static/img/icon_yellow.a52d033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_yellow.png
// module id = 35
// module chunks = 0